import * as React from "react";
import { styled } from "@mui/material/styles";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import InfoIcon from "@mui/icons-material/Info";
import { TargetOrderStyles } from "../../styles/TargetOrder.style";

interface ToolTipProps {
  message: string;
}
export const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} placement="right" classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    maxWidth: "302px",
    padding: "10px",
    height: "auto",
    alignSelf: "center",
    borderRadius: "10px",
    fontSize: theme.typography.pxToRem(14),
  },
}));

const TargetOrderProjectionsToolTip = (props: ToolTipProps) => {
  const classes = TargetOrderStyles();

  return (
    <HtmlTooltip
      title={
        <div className={classes.tooltipContainer}>
          <div>
            <Typography className={classes.toolTipListText}>{props.message}</Typography>
          </div>
        </div>
      }>
      <InfoIcon sx={{ height: "15px", width: "15px" }} />
    </HtmlTooltip>
  );
};

export default TargetOrderProjectionsToolTip;
